import type { FC } from 'react';

import { SongInfos, Title } from './SongInfos.style';

interface ISongInfos {
  songTitle?: string;
  songArtistName?: string;
}

const SongInfo: FC<ISongInfos> = ({ songTitle, songArtistName }) => {
  return (
    <SongInfos>
      <Title>{songTitle}</Title> | {songArtistName}
    </SongInfos>
  );
};

export default SongInfo;
